import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.corporate-settings', {
        url: '/corporateSettings',
        component: 'corporateSettings',
        redirectTo: 'company.corporate-settings.company-profile',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/corporate-settings/corporate-settings.state.js